<div class="modal-dialog modal-dialog-centered" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Tranzakció</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body p-3">

			<div class="alert text-success text-center mb-0" style="background:rgba(0, 0, 0, 0.15);">
				<% if (transaction.manual_entry == 1) { %>
					<div class="text-start">
						<%- include('/ui/form', {
							params: [ 'transaction', transaction, {
								label_width: 3,
							} ],
							fields: [
								{
									type: 'label',
									name: 'type',
									inline: true,
									format: function (value) {
										return `<div class="text-center mb-3"><small class="text-dim">${value}</small></div>`;
									}
								},
								{
									type: 'group',
									title: 'Összeg',
									fields: [
										{
											type: 'select',
											name: 'direction',
											title: 'Irány',
											params: {
												maxItems: 1,
												options: [
													{ value: 'income', html: '<i class="fa fa-arrow-circle-left text-success me-2"></i>Bevétel' },
													{ value: 'expense', html: '<i class="fa fa-arrow-circle-right text-warning me-2"></i>Kiadás' }
												],
												render: {
													item: (item, esc) => `<div>${item.html}</div>`,
													option: (item, esc) => `<div class="option">${item.html}</div>`
												}
											},
											update: function (value) {
												const transaction = Anvil.page.modal.transaction
												if (value == 'income') {
													transaction.type = 'KÉSZPÉNZ BEFIZETÉS'
													if (transaction.amount < 0) transaction.amount = Math.abs(transaction.amount)
												} else {
													transaction.type = 'KÉSZPÉNZ KIFIZETÉS'
													if (transaction.amount > 0) transaction.amount = -Math.abs(transaction.amount)
												}
											}
										},
										{
											type: 'text',
											variant: 'number',
											name: 'amount',
											title: 'Összeg',
											attributes: {
												style: 'color:goldenrod; font-weight:500;'
											},
											update: function (value) {
												const transaction = Anvil.page.modal.transaction
												if (transaction.direction == 'income') {
													if (transaction.amount < 0) transaction.amount = Math.abs(transaction.amount)
												} else {
													if (transaction.amount > 0) transaction.amount = -Math.abs(transaction.amount)
												}
											}
										}
									]
								},
								{
									type: 'text',
									name: 'remark',
									title: 'Közlemény'
								}
							]
						}) %>
					</div>
				<% } else { %>
					<small class="text-dim"><%= transaction.type %></small>

					<% if (transaction.direction == 'income') { %>
						<h2 class="mt-3" style="font-family:'Barlow Condensed'; font-weight:600; color:goldenrod;"><i class="fa fa-arrow-circle-left me-3 text-success"></i><%= Anvil.numeral(transaction.amount).format('0,0') %></h2>
					<% } else { %>
						<h2 class="mt-3" style="font-family:'Barlow Condensed'; font-weight:600; color:peru;"><i class="fa fa-arrow-circle-right me-3 text-warning"></i><%= Anvil.numeral(transaction.amount).format('0,0') %></h2>
					<% } %>
					<span><%= transaction.remark %></span>
				<% } %>
			</div>

			<hr class="w-75 mx-auto" />

			<%- include('/ui/form', {
				params: [ 'transaction', transaction, {
					label_width: 3,
				} ],
				fields: [
					(transaction.manual_entry == 1) ? {
						type: 'select',
						name: 'company_id',
						title: (transaction.direction == 'income') ? 'Küldő' : 'Fogadó',
						params: {
							maxItems: 1,
							options: Anvil.page.companies.data,
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'tax_number', 'name' ],
							render: {
								item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
								option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
							}
						},
						unset_value: null,
						update: function (value) {
							const transaction = Anvil.page.modal.transaction
							if (value) {
								const company = Anvil.page.companies.data.find(c => c.id == value)
								if (transaction.direction == 'income') {
									transaction.sender = company.name
									transaction.receiver = 'Codemakers Kft.'
								} else {
									transaction.receiver = company.name
									transaction.sender = 'Codemakers Kft.'
								}
							}
						}
					} : {
							type: 'label',
							name: (transaction.direction == 'income') ? 'sender' : 'receiver',
							title: (transaction.direction == 'income') ? 'Küldő' : 'Fogadó',
							format: function (value) {
								const link_btn = `<button class="btn btn-sm btn-dark" onclick="Anvil.page.modal.link_ban();"><i class="fa fa-fw fa-link"></i></button>`;
								if (value) {
									return `<h5>${value}</h5><div class="${transaction.resolved_by_ban ? 'text-primary' : 'text-warning'}" style="font-family:monospace;">${transaction.ban.replace(/(.{8})/g, '$1-').slice(0, -1)} ${link_btn}</div>`;
								} else {
									return `-`;
								}
							}
					},
					{
						type: 'html',
						content: '<br />',
					},
					(transaction.manual_entry == 0) ? {
						type: 'label',
						name: 'transaction_d',
						title: 'Elküldve',
						format: function (value) {
							return Anvil.moment(value).format('YYYY.MM.DD.');
						}
					} : {
						type: 'date',
						name: 'transaction_d',
						title: 'Elküldve'
					},
					{
						type: 'label',
						name: 'complete_d',
						title: 'Könyvelve',
						format: function (value) {
							return Anvil.moment(value).format('YYYY.MM.DD.');
						}
					},
					{
						type: 'html',
						content: '<hr class="w-75 mx-auto" />'
					},
					(transaction.resolved_by_ban == 1) ? {
						type: 'html',
						content: '<div class="text-success text-center mb-3"><i class="fa fa-check-circle me-2"></i>Tranzakció számlaszám alapján azonosítva</div>'
					} : undefined,
					(transaction.manual_entry == 0) ? {
						type: 'select',
						name: 'company_id',
						title: 'Párosítás',
						params: {
							maxItems: 1,
							options: Anvil.page.companies.data,
							valueField: 'id',
							labelField: 'name',
							searchField: [ 'tax_number', 'name' ],
							render: {
								item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
								option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
							}
						},
						unset_value: null,
						append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.modal.transaction.company_id = null;"><i class="fa fa-fw fa-times"></i></button>'
					} : undefined,
					{
						type: 'textarea',
						name: 'note',
						title: 'Megjegyzés',
						params: {
							rows: 3
						}
					}
				].filter(Boolean)
			}) %>

		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-save me-2"></i>Mentés</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	async save () {
		const res = await Anvil.exec('transaction/action_save', Anvil.page.modal.transaction)

		if (res === true) {

			// Refresh list
			if ('refresh' in Anvil.page) {
				Anvil.page.refresh()
			}

			// Focus on transaction
			/*
			let grid = Anvil.models.components.Grid.find('#transaction_grid')
			grid.select(grid.list.getById(Anvil.page.modal.transaction.id), true)
			*/

			// Close modal
			Anvil.page.modal.close()
		}
	},

	link_ban () {
		const transaction = Anvil.page.modal.transaction

		Anvil.page.modal.close()
		Anvil.exec('company_ban/modal_link_ban', transaction.ban, (transaction.direction == 'income' ? transaction.sender.replaceAll('\'', '').replaceAll('\"', '') : transaction.receiver.replaceAll('\'', '').replaceAll('\"', '')))
	}
})
</script>
